import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { mainAction } from "../../Redux/Actions";
import { Select, Space } from "antd";
import { RemoveAccents } from "../../Utils";

const SelectRecipientComp = React.forwardRef(
  (
    {
      onSelected = () => {},
      onActive = 0,
      isReload = 0, //reload select box
      parentId = 0,
      onReload = () => {},
    },
    ref
  ) => {
    const dispatch = useDispatch();

    const [data, setData] = useState([]);
    const [valueS, setValueS] = useState(0);
    const onSelecteItem = (item) => {
      onSelected(item);
      setValueS(item);
    };

    useEffect(() => {
      onGetData();
    }, []);

    useEffect(() => {
      if (data.length === 0) onGetData();
      if (onActive !== 0) {
        let _dataActive = data.find((p) => p.value === onActive).value;
        setValueS(_dataActive);
      } else {
        setValueS(0);
      }
    }, [onActive]);

    useEffect(() => {
      if (isReload === 1) {
        onGetData();
        onReload(false);
      }
    }, [isReload]);

    useEffect(() => {
      onGetData();
    }, [parentId]);

    const onGetData = async () => {
      const params = {
        Json: '{"CustomerId":' + parentId + "}",
        func: "CPN_spRecipientAddress_Like",
      };

      // call redux saga
      const list = await mainAction.API_spCallServer(params, dispatch);
      let dataOptions = [
          {
            value: 0,
            label:
              list.length > 0 ? "Chọn người nhận có sẵn" : "Chưa có người nhận",
          },
        ],
        IsActive = 0;
      if (onActive === 0) setValueS(0);
      list.forEach((element, index) => {
        let option = {
          value: element.RecipientId,
          label:
            element.RecipientName +
            " - " +
            element.Phone +
            " - " +
            element.Address,
          element: element,
          obj: element,
        };
        dataOptions.push(option);
        if (element.Id === onActive) IsActive = 1;
      });
      setData(dataOptions);
      if (IsActive === 1) {
        let dataActive = dataOptions.find((a) => a.value === onActive).value;
        setValueS(dataActive);
      } else setValueS(0);
      onReload(false);
    };

    return (
      <Select
        onChange={onSelecteItem}
        style={{
          width: "100%",
        }}
        placeholder="Địa chỉ nhận hàng"
        defaultValue={valueS}
        options={data}
        optionRender={(option) => (
          <Space>
            <span role="img" aria-label={option.label}>
              {option.label}
            </span>
          </Space>
        )}
        ref={ref}
        showSearch
        filterOption={(input, option) =>
          RemoveAccents(option.label.toLowerCase()).includes(
            RemoveAccents(input.toLowerCase())
          )
        }
      />
    );
  }
);

export const SelectRecipient = React.memo(SelectRecipientComp);
